module.exports = __webpack_public_path__ + "media/application/images/ui/filter-dropdown-active-cab707917277d3e3be80ce27744021e2.svg";